import type { VisitType } from '@/types/queue'

export { isToday, formatDateTime } from '@/lib/dates'

export function visitTypeBadgeVariant(visitType: VisitType): 'default' | 'secondary' | 'outline' {
  switch (visitType) {
    case 'initial': return 'default'
    case 'follow_up': return 'secondary'
    case 'refill': return 'outline'
    default: return 'secondary'
  }
}

export function visitTypeLabel(visitType: VisitType): string {
  switch (visitType) {
    case 'initial': return 'Initial'
    case 'follow_up': return 'Follow-Up'
    case 'refill': return 'Refill'
    default: return visitType
  }
}
